<template>
  <div>
    <input type="file" style="display:none" ref="hiddenFileInput" @change="uploadFileChange" />

    <template v-for="item in localValue">
      <template v-if="!item.readonly&&!disabled">
        <a-button-group style="width: 100%">
          <a-button style="width: 150px;text-align: left;overflow: hidden" @click="viewOrDownloadFile(item)">
            <a style="text-decoration: underline" :title="item.name">{{item.name?(item.name.length>7?(item.name.substring(0,6)+'...'):item.name):''}}</a>
          </a-button>
          <a-button :disabled="disabled" v-show="item.name&&!disabled" type="danger" icon="delete" @click="deleteFile(item)"/>
        </a-button-group>
      </template>
      <template v-else-if="localValue&&localValue.length">
        <span  style="display: inline-block;width: 100%;font-size:14px;line-height:30px;font-weight: 700;color: #3498db;text-decoration:underline;cursor: pointer" @click="viewOrDownloadFile(item)">{{item.name}}</span>
      </template>
      <template v-else>
        <span style="display: inline-block;width: 100%;font-size:14px;line-height:30px;font-weight: 700;color:#7c7c7c;" >暂无附件</span>
      </template>
    </template>

    <a-button v-if="!disabled" type="primary" icon="upload" :loading="iconLoading" @click="choiceImg">
      上传
    </a-button>



    <!--<template v-if="!disabled">-->
      <!--<a-button-group v-for="item in localValue" style="width: 100%">-->
        <!--<a-button style="width: 100%;text-align: left" @click="viewOrDownloadFile(item)">-->
          <!--<a style="text-decoration: underline">{{item.name}}</a>-->
        <!--</a-button>-->
        <!--<a-button :disabled="disabled" v-show="item.name&&!disabled" type="danger" icon="delete" @click="deleteFile(item)"/>-->
      <!--</a-button-group>-->
      <!--<a-button :disabled="disabled" type="primary" icon="upload" :loading="iconLoading" @click="choiceImg">-->
        <!--上传-->
      <!--</a-button>-->
    <!--</template>-->
    <!--<template v-else-if="localValue&&localValue.length">-->
      <!--<template v-for="item in localValue">-->
        <!--<span  style="display: inline-block;width: 100%;font-size:14px;line-height:30px;font-weight: 700;color: #3498db;text-decoration:underline;cursor: pointer" @click="viewOrDownloadFile(item)">{{item.name}}</span>-->
      <!--</template>-->
    <!--</template>-->
    <!--<span v-else style="display: inline-block;width: 100%;font-size:14px;line-height:30px;font-weight: 700;color:#7c7c7c;" >暂无附件</span>-->
  </div>
</template>

<script>
import isImage from 'is-image'
import {upload} from '../../../api/api'
import mixin from '../mixin/AExtArrayMixin'
export default {
    name: "AExtUpload",
    mixins:[mixin],
    props:{
        disabled:{
            type:Boolean,
            default:false
        },
        belongId:{
            type:String,
            default: ''
        },
        belongType:{
            type:String,
            default:''
        },
        belongSmallType:{
            type:String,
            default:''
        }
    },
    data(){
      return{
          localValue:[],
          iconLoading:false
      }
    },
    methods: {
        choiceImg() {
            this.$refs.hiddenFileInput.dispatchEvent(new MouseEvent('click'))
        },
        uploadFileChange(){
            if(this.$refs.hiddenFileInput.files[0].name.toLowerCase().indexOf('.pdf')===-1
                &&this.$refs.hiddenFileInput.files[0].name.toLowerCase().indexOf('.jpg')===-1
                &&this.$refs.hiddenFileInput.files[0].name.toLowerCase().indexOf('.png')===-1)
            {
                this.$message.warn('仅允许上传图片或pdf，请将文件先转换为pdf再进行上传!');
                return;
            }
            this.iconLoading=true;
            upload({belongId:this.belongId,belongType:this.belongType,belongSmallType:this.belongSmallType,file:this.$refs.hiddenFileInput.files[0]}).then(result=>{
                if (result.data&&result.data.succ)
                {
                    let resultData=result.data.data;
                    this.localValue.push(resultData);
                }
                this.iconLoading=false;
                this.$refs.hiddenFileInput.value = '';
            }).catch(()=>{
                this.iconLoading=false;
                this.$refs.hiddenFileInput.value = '';
            })
        },
        deleteFile(item)
        {
            this.localValue.remove(item);
        },
        viewOrDownloadFile(item)
        {
            if(item.suffix==='pdf'
                ||item.suffix==='jpg'
                ||item.suffix==='png')
            {
                //TODO:预览图片
                this.$plugins.preview(item.id,item.suffix)
            }
            if (this.url)
            {

            }
        }
    }
}
</script>

<style scoped>

</style>